'use client';

import { __resetStyles, mergeClasses } from "@griffel/react";
import { tokens } from "@fluentui/react-theme";
export const flatTreeClassNames = {
  root: 'fui-FlatTree'
};
const useBaseStyles = /*#__PURE__*/__resetStyles("rnv2ez3", null, [".rnv2ez3{display:flex;flex-direction:column;row-gap:var(--spacingVerticalXXS);}"]);
export const useFlatTreeStyles_unstable = state => {
  const baseStyles = useBaseStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(flatTreeClassNames.root, baseStyles, state.root.className);
  return state;
};